module.exports = __webpack_public_path__ + "static/img/CF.fc85711d.svg";